/* eslint-disable no-irregular-whitespace */
import request from '@/utils/request'
let preBase = 'mixApi'

// 厦门国际银行新客礼项目-登录接口
export const login = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGift/login`,
    method: 'post',
    data,
    // custom: true,
    // hideLoading: true,
  })
}
// 厦门国际银行新客礼项目-校验接口
export const xibNewCustomerCheck = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGift/check`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行新客礼项目-领取接口
export const xibNewCustomerReceive = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGift/receive`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行新客礼项目-查询领奖状态接口
export const queryReceiveStatus = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGift/queryReceiveStatus`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
// 厦门国际银行新客礼项目-查询领取记录接口
export const getRecordPages = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGift/queryReceiveRecordDetail`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankPromotionJhToken'),
    data,
    // hideLoading: true,
  })
}
